export class HashCodeUtils {
    /**
     * A hashing function for strings.
     *
     * @param str {String} A string to be hashed.
     * @return {Number} A hash code for the provided string.
     */
    public static hashCode(str: string): number {
        let hash: number = 0;
        for (let i: number = 0; i < str.length; i++) {
            const chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

    /**
     * A symmetric hashing function for strings.
     *
     * @param str1 {String} The first string to be hashed.
     * @param str2 {String} The second string to be hashed.
     * @return {Number} A hash code for the provided strings such that
     * symmetricHashCode(str1, str2) == symmetricHashCode(str2, str1).
     */
    public static symmetricHashCode(str1: string, str2: string): number {
        return HashCodeUtils.hashCode(str1) + HashCodeUtils.hashCode(str2);
    }
}
